import { JRCInputCheckbox } from 'components/Form/Input/JRCInputCheckbox/JRCInputCheckbox';

import React from 'react';
import { useForm } from 'react-hook-form';

import { CheckboxOption } from 'types';

export const EditorInputToggle = ({
    label,
    initialValue,
    description,
    options,
    onChange,
}: {
    label?: string;
    initialValue: boolean;
    description?: string;
    options: CheckboxOption[];
    onChange: (value: boolean) => void;
}) => {
    const { control, watch } = useForm({
        defaultValues: {
            checkboxToggle: initialValue ?? false,
        },
        criteriaMode: 'all',
    });

    React.useEffect(() => {
        const subscription = watch((data) => {
            onChange(data.checkboxToggle ?? false);
        });
        return () => subscription.unsubscribe();
    }, [watch, onChange]);

    return (
        <JRCInputCheckbox
            name={'checkboxToggle'}
            checkboxMode={'toggle'}
            valueTypeIsBoolean={true}
            description={description}
            label={label}
            options={options}
            control={control as any}
        />
    );
};
